import { usePut } from '../../HttpClient';
import { TransactionReasonModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useUpdateTransactionReason() {
  const put = usePut(true, "tms");
  const updateTransactionReason = (id: string, request: TransactionReasonModel) =>
    put<{ id: string }>(`${referenceDataBaseUrl}/transaction-reasons/${id}`, request);

  return useMutationWithErrorHandling({
    mutationFn: async ({ id, request }: { id: string; request: TransactionReasonModel }) =>
      await updateTransactionReason(id, request),
  });
}
